import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ShoppingBag, ChevronRight } from "lucide-react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { useLang } from "@/lib/lang";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StorePreview() {
  const { lang } = useLang();
  const T = lang === "fr" ? FR : EN;
  const [products, setProducts] = useState([]);
  const [currency, setCurrency] = useState("CAD");

  useEffect(() => {
    axios.get(`${API}/store/products`).then(r => {
      setProducts(r.data.products);
      setCurrency(r.data.currency);
    }).catch(() => {});
  }, []);

  return (
    <section className="relative border-t border-zinc-200 bg-stone-50 px-6 md:px-12 py-20" data-testid="landing-store-preview">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <div className="mb-4 flex items-center gap-3 text-[#8b6f3d]">
              <div className="h-px w-12 bg-[#8b6f3d]/40" />
              <span className="font-mono-data text-[11px] uppercase tracking-[0.3em]">{T.tag}</span>
            </div>
            <h2 className="font-serif-mystery text-4xl md:text-5xl text-zinc-900 leading-[1.05] mb-3">
              {T.title}<br /><span className="italic text-[#8b6f3d]">{T.titleItalic}</span>
            </h2>
            <p className="text-zinc-600 max-w-2xl">{T.intro}</p>
          </div>
          <Link to="/store">
            <Button data-testid="landing-store-cta" className="bg-[#8b6f3d] hover:bg-[#a1854b] text-white rounded-full h-12 px-6">
              <ShoppingBag size={16} className="mr-2" />
              {T.viewAll}
              <ChevronRight size={16} className="ml-1" />
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {products.slice(0, 5).map(p => (
            <Link to="/store" key={p.id} className="group" data-testid={`landing-product-${p.id}`}>
              <div className="aspect-square bg-white rounded-xl overflow-hidden border border-zinc-200 group-hover:border-[#8b6f3d] transition-all group-hover:-translate-y-1 group-hover:shadow-lg">
                <img src={p.image} alt={p.name[lang]} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="mt-2 text-xs text-zinc-700 leading-tight line-clamp-2">{p.name[lang]}</div>
              <div className="text-sm font-medium text-[#8b6f3d]">{p.price.toFixed(2)} {currency}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

const FR = {
  tag: "Nouveautés · Boutique",
  title: "5 t-shirts exclusifs",
  titleItalic: "à découvrir",
  intro: "Édition limitée inspirée des lieux les plus mystérieux de la carte : OVNIs, apparitions, cyberpunk yōkai, trésors et cartographie mondiale.",
  viewAll: "Voir la boutique",
};
const EN = {
  tag: "New arrivals · Store",
  title: "5 exclusive T-shirts",
  titleItalic: "to discover",
  intro: "Limited edition inspired by the map's most mysterious places: UFOs, apparitions, cyberpunk yōkai, treasures and world cartography.",
  viewAll: "Visit the store",
};
